
import TitleBox from '@/components/CSS/TitleBox'
const advise = () => import('@/pages/home/advise')
const stages = () => import('@/pages/home/stages')
const jobs = () => import('@/pages/home/jobs')
export default {
	components: {
		TitleBox,
		advise,
		stages,
		jobs
	},
	computed: {
		articleComponents() {
			return this.navIndexTitle !== '投诉建议' && this.navIndexTitle !== '垫付分期' && this.navIndexTitle !== '招贤纳士'
		}
	},
	data() {
		return {
			loading: null,
			navIndexTitle: null,
			navIndex: null,
			navList: [],
			viewer: {},
			articleContent: {
				content: null,
				createTime: null,
				id: null,
				title: null
			},
			routeTitle: null
		}
	},
	head() {
		return {
			title: '业务介绍-找回包赔-盼之代售-手游网游账号买号卖号平台',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售游戏交易平台业务介绍，提供游戏账号找回包赔，挂牌代售，中介担保的交易服务。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '业务介绍，游戏账号交易，盼之代售'
				}
			]
		}
	},
	filters: {
		get_chinese(num) {
			switch (num) {
				case 1:
					return '一'
				case 2:
					return '二'
				case 3:
					return '三'
				case 4:
					return '四'
				case 5:
					return '五'
				case 6:
					return '六'
				case 7:
					return '七'
				case 8:
					return '八'
				case 9:
					return '九'
				default:
					return num
			}
		}
	},
	watch: {
		$route: {
			handler: function (route) {
				this.routeTitle = route.params.title
				if (this.routeTitle) this.getNavList()
			},
			immediate: true
		}
	},
	created() {
		if (!this.routeTitle) this.getNavList()
	},
	methods: {
		navHandler(item) {
			const info = {
				action: {
					event: 'BUSINESS_INFO'
				}
			}
			this.$api.getRelatedClicks(info).then(res => {
				if (res.success) {
					if (this.$route.params.title === item.title) return
					this.$router.push(`/business/${item.title}`)
				}
			})
		},
		getNavList() {
			this.$api.businessList().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.navList = res.data
				this.navIndexTitle = this.routeTitle ? this.routeTitle : res.data[0].title // 选中第一个
				this.navIndex = res.data[0].id // 选中第一个
				this.getArticle(res.data[0].id)
			})
		},
		getArticle() {
			const pageData = ['投诉建议', '垫付分期', '招贤纳士']
			// 单独接口
			if (pageData.indexOf(this.navIndexTitle) !== -1) {
				return
			}
			this.loading = true
			let p = {
				action: {
					title: this.navIndexTitle
				}
			}
			this.$api.articleDetail(p).then(res => {
				this.loading = false
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.articleContent = res.data
			})
		}
	}
}
